///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    if (document.querySelector('.js-report-index')) {
      // We're on the report index page, so run report-related JS.

      const reportSelect = document.querySelector('[data-teaching-tool-report]'),
            teachingToolReportName = reportSelect.dataset['teachingToolReport'],
            teachingToolOptions = document.querySelectorAll('.js-teaching-tool-option'),
            cancelledCasesReportName = reportSelect.dataset['cancelledCasesReport'],
            openCasesReportName = reportSelect.dataset['openCasesReport'],
            openOrCancelledCasesOptions =
                document.querySelectorAll('.js-open-or-cancelled-cases-option'),
            dateFields = document.querySelector('.js-date-fields'),
            includeAllReviews = document.querySelector('.js-include-all-reviews');

      // Show report-specific fields for the selected report,
      // and hide report-specific fields for other reports.
      //
      // The Open Cases report has an option to hide the
      // date fields, so be sure that option is unchecked
      // when a report is selected.
      reportSelect.addEventListener('change', (e) => {
        includeAllReviews.checked = false;
        includeAllReviews.dispatchEvent(new Event('change'));

        if (reportSelect.value === teachingToolReportName) {
          teachingToolOptions.forEach((ttOption) => {
            ttOption.classList.remove('d-none');
          });
          openOrCancelledCasesOptions.forEach((ttOption) => {
            ttOption.classList.add('d-none');
          });
        } else if (reportSelect.value === cancelledCasesReportName ||
                   reportSelect.value === openCasesReportName) {
          teachingToolOptions.forEach((ttOption) => {
            ttOption.classList.add('d-none');
          });
          openOrCancelledCasesOptions.forEach((ttOption) => {
            ttOption.classList.remove('d-none');
          });
        } else {
          teachingToolOptions.forEach((ttOption) => {
            ttOption.classList.add('d-none');
          });
          openOrCancelledCasesOptions.forEach((ttOption) => {
            ttOption.classList.add('d-none');
          });
        }
      });

      // If the "Include All Reviews" box is checked,
      // hide the date fields. Otherwise, show them.
      includeAllReviews.addEventListener('change', (e) => {
        if (includeAllReviews.checked) {
          dateFields.classList.add('d-none');
        } else {
          dateFields.classList.remove('d-none');
        }
      });

      // Trigger the event once on page load.
      reportSelect.dispatchEvent(new Event('change'));
    }
  });
}());
